var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: "Please confirm",
        "ok-variant": "success",
        "hide-header-close": "",
        centered: "",
      },
      on: {
        hidden: function ($event) {
          return _vm.$emit("cancel")
        },
        ok: _vm.onClickApprove,
      },
    },
    [
      _c("p", [_vm._v("You are going to approve this facility")]),
      _vm._v(" "),
      _vm.license
        ? _c("strong", [
            _vm._v(
              _vm._s(`${_vm.license.facility.name} - ${_vm.license.number}`)
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: { value: true, "unchecked-value": false },
          model: {
            value: _vm.is_to_buy,
            callback: function ($$v) {
              _vm.is_to_buy = $$v
            },
            expression: "is_to_buy",
          },
        },
        [
          _vm._v("\n    Permit "),
          _c("strong", [_vm._v("Purchase")]),
          _vm._v(" operations\n  "),
        ]
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-checkbox",
        {
          attrs: { value: true, "unchecked-value": false },
          model: {
            value: _vm.is_to_sell,
            callback: function ($$v) {
              _vm.is_to_sell = $$v
            },
            expression: "is_to_sell",
          },
        },
        [
          _vm._v("\n    Permit "),
          _c("strong", [_vm._v("Sale")]),
          _vm._v(" operations\n  "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }